import Cookies from 'js-cookie';
import { getBrowserLang, getCountryLang, getArea } from "../../util/getBrowserLang";
import { area } from '../../xss/white-list';

const app = {
  state: {
    language: Cookies.get('singleLanguage') || Cookies.get('language') || getBrowserLang(),
    API_BASE_URL: '',
    UI_BASE_URL: '',

    area: getArea(),

    isMobile: false,
    // isPad: false,

    device: { 'isMobile': false, 'isPad': false, 'isPC': false, 'isApple': false },
    innerBrowserApp: '',
    alertMsg: '',
    countryLang: getCountryLang(),

    homeBannerHeight: '0px', //根据首页banner的高度，计算首页背景图的y偏移量
    messageNum: '',
    mobileRoute: '',
    showGameList: false,
    showExplorer: false,
    cosRegionStr: null,
    platform: '',
    newComingGuide: window.localStorage.getItem('newComingGuide') || true
  },
  mutations: {
    SET_LANGUAGE: (state, language) => {
      state.language = language;
    },
    SET_AREA: (state, area) => {
      state.area = area;
    },
    SET_COUNTRY_LANG: (state, countryLang) => {
      state.countryLang = countryLang;
    },

    SET_DEVICE: (state, device) => {
      state.device = device;
    },
    SET_INNERBROWSERAPP: (state, innerBrowserApp) => {
      state.innerBrowserApp = innerBrowserApp;
    },
    SET_ALERTMSG: (state, alertMsg) => {
      console.log('alertMsg', alertMsg);

      state.alertMsg = alertMsg;
    },
    SET_HOMEBANNERHEIGHT: (state, homeBannerHeight) => {
      state.homeBannerHeight = homeBannerHeight;
    },
    SET_MESSAGE_NUM: (state, messageNum) => {
      state.messageNum = messageNum;
    },
    SET_MOBILE_ROUTE: (state, mobileRoute) => {
      state.mobileRoute = mobileRoute;
    },
    SET_SHOW_GAME_LIST: (state, showGameList) => {
      state.showGameList = showGameList;
    },
    SET_EXPLORER_LIST: (state, showExplorer) => {
      state.showExplorer = showExplorer;
    },
    SET_COS_REGION_STR: (state, cosRegionStr) => {
      state.cosRegionStr = cosRegionStr;
    },
    SET_PLATFORM: (state, platform) => {
      state.platform = platform;
    },
    // newComingGuide
    SET_NEWCOMINGGUIDE: (state, newComingGuide) => {
      state.newComingGuide = newComingGuide;
    }
  },
  actions: {
    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language);
      // Cookies.set('language', language, { expires: 356 });
      console.log(getArea(), '---area');
      console.log(Cookies.get('language'), '---language');
      commit('SET_AREA', getArea());
    },
    setDevice({ commit }, clientWidth) {
      let sUserAgent = navigator.userAgent.toLowerCase();
      let bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
      let bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
      let bIsMidp = sUserAgent.match(/midp/i) == "midp";
      let bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
      let bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
      let bIsAndroid = sUserAgent.match(/android/i) == "android";
      let bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
      let bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
      let bIsTablet = sUserAgent.match(/tablet/i) == "tablet";
      let bIsGoolgeBotMobile = (sUserAgent.match(/Goolgebot/i) == "Goolgebot" &&
        (sUserAgent.match(/Mobile/i) || "Mobile" || sUserAgent.match(/Android/i) == "Android" || sUserAgent.match(/AppleWebKit/i)
        ) == "AppleWebKit");

      let device = {};
      if (bIsIphoneOs) {
        device.isApple = true;
      }
      if (window.location.host.includes('mprerender.gameexp.com') ||
        window.location.host.includes('mprerender.gameinfo.xyz') ||
        window.location.host.includes('mprerender-jp.gameexp.com')) {
        device.isMobile = true;
      } else {
        let isMobile = (bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM || bIsGoolgeBotMobile) && !bIsTablet;
        let isPad = bIsIpad || bIsTablet;
        if (!isMobile && !isPad) {
          device.isPC = true;
        } else if (isPad) {
          device.isPad = true;
        } else {
          device.isMobile = true;
        }
      }
      commit('SET_DEVICE', device);
      // 注释cookies：当前cookies只是保存并没有使用
      // Cookies.set('deivce', device);
    },
    setInnerBrowserApp({ commit }) {
      let ua = navigator.userAgent || navigator.vendor || window.opera;
      if ((ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1)) {
        commit('SET_INNERBROWSERAPP', 'fb');
        // Cookies.set('innerBrowserApp', 'fb');
      }
      else if ((ua.indexOf("instagram") > -1)) {
        commit('SET_INNERBROWSERAPP', 'ins');
        // Cookies.set('innerBrowserApp', 'ins');
      }
      else if ((ua.indexOf("snapchat") > -1) || ua.indexOf("Snapchat") > -1) {
        commit('SET_INNERBROWSERAPP', 'snapchat');
        // Cookies.set('innerBrowserApp', 'snapchat');
      }
      else if ((ua.indexOf("reddit") > -1)) {
        commit('SET_INNERBROWSERAPP', 'reddit');
        // Cookies.set('innerBrowserApp', 'reddit');
      }
      else if ((ua.indexOf("messneger") > -1)) {
        commit('SET_INNERBROWSERAPP', 'messneger');
        // Cookies.set('innerBrowserApp', 'messneger');
      }
      else {
        commit('SET_INNERBROWSERAPP', '');
        // Cookies.set('innerBrowserApp', '');
      }
    },
    setAlertMsg({ commit }, alertMsg) {
      console.log('alertMsg', alertMsg);
      commit('SET_ALERTMSG', alertMsg);
    },
    setCountryLang({ commit }, countryLang) {
      commit('SET_COUNTRY_LANG', countryLang);
    },
    setArea({ commit }) {

    },
    setMessageNum({ commit }, messageNum) {
      commit('SET_MESSAGE_NUM', messageNum);
    },
    setHomeBannerHeight({ commit }, homeBannerHeight) {
      commit('SET_HOMEBANNERHEIGHT', homeBannerHeight);
    },
    setMobileRoute({ commit }, mobileRoute) {
      commit('SET_MOBILE_ROUTE', mobileRoute);
    },
    setShowGameList({ commit }, showGameList) {
      commit('SET_SHOW_GAME_LIST', showGameList);
    },
    setExplorerList({ commit }, showExplorer) {
      commit('SET_EXPLORER_LIST', showExplorer);
    },
    setCosRegion({ commit }, cosRegionStr) {
      commit('SET_COS_REGION_STR', cosRegionStr);
    },
    setPlatform({ commit }) {
      let platform;
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        platform = 'ios';
      } else if (/(Android)/i.test(navigator.userAgent)) {
        platform = 'android';
      } else {
        platform = 'pc';
      }
      commit('SET_PLATFORM', platform);
    },
    setNewComingGuide({ commit }, newComingGuide) {
      commit('SET_NEWCOMINGGUIDE', newComingGuide);
    }
  }
};

export default app;
